(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.desktopMenu = this.header.querySelector('.header-pill__menu-desktop');
      this.mobileMenu = this.header.querySelector('.header-pill__menu-mobile');
      this.setHeaderHeight();
      this.checkMenuFit();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.checkMenuFit.bind(this));
      if (document.fonts) document.fonts.ready.then(this.checkMenuFit.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    /* Switches the pill from the full text menu to the hamburger whenever the text menu
       actually wraps to a second line, rather than trusting a single fixed breakpoint
       to predict that for every combination of logo width/menu length. Removing the
       compact class first forces the desktop menu back into normal flow before
       measuring — reading getBoundingClientRect forces layout but not paint, so
       toggling the class back and forth here happens within one JS task and never
       produces a visible flash. */
    checkMenuFit() {
      if (!this.desktopMenu || !this.mobileMenu) return;
      this.header.classList.remove('header-menu-compact');
      if (this.isMenuWrapped()) {
        this.header.classList.add('header-menu-compact');
      }
    }

    isMenuWrapped() {
      const items = this.desktopMenu.querySelectorAll('.list-menu__item');
      if (items.length < 2) return false;
      const firstTop = items[0].getBoundingClientRect().top;
      const lastTop = items[items.length - 1].getBoundingClientRect().top;
      return Math.abs(lastTop - firstTop) > 2;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class PillSearchToggle extends HTMLElement {
    connectedCallback() {
      this.pill = this.closest('.header-pill');
      this.button = this.querySelector('[data-pill-search-button]');
      this.form = this.querySelector('[data-pill-search-form]');
      this.input = this.querySelector('[data-pill-search-input]');

      this.button.addEventListener('click', () => this.toggle());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
      document.addEventListener('click', (event) => {
        if (this.isOpen() && !this.contains(event.target)) this.close();
      });
    }

    isOpen() {
      return this.pill.classList.contains('is-search-open');
    }

    toggle() {
      this.isOpen() ? this.close() : this.open();
    }

    open() {
      this.pill.classList.add('is-search-open');
      this.button.setAttribute('aria-expanded', 'true');
      this.input.focus();
    }

    close() {
      this.pill.classList.remove('is-search-open');
      this.button.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('pill-search-toggle', PillSearchToggle);

  } catch(e) { console.error(e); }
})();
})();
